<template>
    <div class="ai-parameter-select">
        <RedesignFormLabel
            :label="label"
            class="mb-2"
        />
        <VcSelectGrouped
            :model-value="value"
            :options="groupedOptions"
            :config="selectConfig"
            :filterable="filterable"
            :multiple="multiple"
            :collapse-tags="collapseTags"
            :clearable="clearable"
            :placeholder="placeholder"
            class="parameter-select"
            @update:model-value="handleInput"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VcSelectGrouped } from '@voicenter-team/voicenter-ui-plus'
import type { TranslateResult } from 'vue-i18n'

import RedesignFormLabel from '@/components/RedesignBaseComponents/Form/RedesignFormLabel.vue'
import type { ParameterGroup } from '@/types/widgetParameters'

const props = withDefaults(defineProps<{
    value: string | string[]
    label: string | TranslateResult
    placeholder?: string | TranslateResult
    parameterGroups: ParameterGroup[]
    multiple?: boolean
    filterable?: boolean
    collapseTags?: boolean
    clearable?: boolean
}>(), {
    placeholder: '',
    multiple: false,
    filterable: true,
    collapseTags: true,
    clearable: false
})

const emit = defineEmits<{
    (e: 'input', value: string | string[]): void
}>()

const selectConfig = {
    labelKey: 'label',
    valueKey: 'value'
} as const

/* The grouped select reads labels off a key, so the fallback to the raw value has to be baked in */
const groupedOptions = computed(() => props.parameterGroups.map(group => ({
    label: group.label,
    options: group.options.map(option => ({
        value: option.value,
        label: option.label || option.value
    }))
})))

function handleInput (val: string | string[]) {
    emit('input', val)
}
</script>

<style lang="scss" scoped>
.ai-parameter-select {
    max-width: 400px;

    .parameter-select {
        max-width: 360px;
    }
}
</style>
